export const initial = {
    signs: [
        {
            name: 'aries',
            start: 'Mar 21',
            end: 'Apr 19',
        },
        {
            name: 'taurus',
            start: 'Apr 20',
            end: 'May 20',
        },
        {
            name: 'gemini',
            start: 'May 21',
            end: 'Jun 20',
        },
        {
            name: 'cancer',
            start: 'Jun 21',
            end: 'Jul 22',
        },
        {
            name: 'leo',
            start: 'Jul 23',
            end: 'Aug 22',
        },
        {
            name: 'virgo',
            start: 'Aug 23',
            end: 'Sep 22',
        },
        {
            name: 'libra',
            start: 'Sep 23',
            end: 'Oct 22',
        },
        {
            name: 'scorpio',
            start: 'Oct 23',
            end: 'Nov 21',
        },
        {
            name: 'sagittarius',
            start: 'Nov 22',
            end: 'Dec 21',
        },
        {
            name: 'capricorn',
            start: 'Dec 22',
            end: 'Jan 19',
        },
        {
            name: 'aquarius',
            start: 'Jan 20',
            end: 'Feb 18',
        },
        {
            name: 'pisces',
            start: 'Feb 19',
            end: 'Mar 20',
        },
    ],
};



// WEBPACK FOOTER //
// ./app/reducers/zodiac.js